import React, { Component } from "react";
import { Spin, Radio, Space, message, Checkbox } from "antd";
import Bridge from "../../utils/Bridge";
import { logEvent } from "../../utils/analytics";

export default class GeneticTesting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      have_you_been_genetically_tested: "",
      options_applied_for_genetic_testing: [],
      als_or_ftd_gene_affected_to_you_or_your_family_member: [],
      afftected_to_other_specification: "",
      loading: false,
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.ecas_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (
                item.field ==
                "Have you been genetically tested for a gene mutation associated with ALS or FTD?"
              ) {
                this.setState({ have_you_been_genetically_tested: item.value });
              }
              if (
                item.field ==
                "Please select the option that most applies to your genetic status"
              ) {
                this.setState({
                  options_applied_for_genetic_testing: item.value
                    ? JSON.parse(item.value)
                    : [],
                });
              }
              if (
                item.field ==
                "If known, which ALS and/or FTD related gene(s) are you affected by or have affected your genetic family?"
              ) {
                this.setState({
                  als_or_ftd_gene_affected_to_you_or_your_family_member:
                    item.value ? JSON.parse(item.value) : [],
                });
              }
              if (
                item.field ==
                "If known, which ALS and/or FTD related gene(s) are you affected by or have affected your genetic family?, Other"
              ) {
                this.setState({
                  afftected_to_other_specification: item.value,
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  save = () => {
    if (!this.state.have_you_been_genetically_tested) {
      message.warning(
        "Please select value of 'Have you been genetically tested for a gene mutation associated with ALS or FTD?' field"
      );
      return;
    }
    if (this.state.options_applied_for_genetic_testing.length == 0) {
      message.warning(
        "Please select value of 'Please select the option that most applies to your genetic status' field"
      );
      return;
    }
    if (this.state.options_applied_for_genetic_testing.length == 0) {
      message.warning(
        "Please select value of 'Please select the option that most applies to your genetic status' field"
      );
      return;
    }
    if (
      this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.length ==
      0
    ) {
      message.warning(
        "Please select value of 'If known, which ALS and/or FTD related gene(s) are you affected by or have affected your genetic family?' field"
      );
      return;
    }
    let questions = [
      {
        parent_field:
          "Have you been genetically tested for a gene mutation associated with ALS or FTD?",
        field:
          "Have you been genetically tested for a gene mutation associated with ALS or FTD?",
        value: this.state.have_you_been_genetically_tested,
      },
      {
        parent_field:
          "Please select the option that most applies to your genetic status",
        field:
          "Please select the option that most applies to your genetic status",
        value: JSON.stringify(this.state.options_applied_for_genetic_testing),
      },
      {
        parent_field:
          "If known, which ALS and/or FTD related gene(s) are you affected by or have affected your genetic family?",
        field:
          "If known, which ALS and/or FTD related gene(s) are you affected by or have affected your genetic family?",
        value: JSON.stringify(
          this.state.als_or_ftd_gene_affected_to_you_or_your_family_member
        ),
      },
      // {
      //   parent_field:
      //     "If known, which ALS and/or FTD related gene(s) are you affected by or have affected your genetic family?, Other",
      //   field:
      //     "If known, which ALS and/or FTD related gene(s) are you affected by or have affected your genetic family?, Other",
      //   value: this.state.afftected_to_other_specification,
      // },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "9",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.ecas_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_saved", { section: "genetic_testing" });
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                setTimeout(() => {
                  window.location.assign("/dashboard");
                }, 3000);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeAppliedForGeneticTesting = (e) => {
    let value = e.target.value;
    let tempArr = this.state.options_applied_for_genetic_testing;
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({ options_applied_for_genetic_testing: newArray });
    } else {
      tempArr.push(value);
      this.setState({ options_applied_for_genetic_testing: tempArr });
    }
  };
  onChangeAffectedByOrAffectedYourFamilyMember = (e) => {
    let value = e.target.value;
    let tempArr =
      this.state.als_or_ftd_gene_affected_to_you_or_your_family_member;
    if (
      this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
        "Other"
      )
    ) {
      this.setState({
        afftected_to_other_specification: "",
      });
    }
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({
        als_or_ftd_gene_affected_to_you_or_your_family_member: newArray,
      });
    } else {
      tempArr.push(value);
      this.setState({
        als_or_ftd_gene_affected_to_you_or_your_family_member: tempArr,
      });
    }
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>GENETIC TESTING AND GENE MUTATION</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2">
                Have you been genetically tested for a gene mutation associated
                with ALS or FTD? <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    have_you_been_genetically_tested: event.target.value,
                  })
                }
                value={this.state.have_you_been_genetically_tested}
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="input-heading">
                Please select the option that most applies to your genetic
                status
                <span className="text-danger">*</span>
              </label>
              <ul>
                <li>
                  <Checkbox
                    value={
                      "I have tested positive for an ALS and/or FTD related mutation"
                    }
                    onChange={this.onChangeAppliedForGeneticTesting}
                    checked={
                      this.state.options_applied_for_genetic_testing.includes(
                        "I have tested positive for an ALS and/or FTD related mutation"
                      )
                        ? true
                        : false
                    }
                  >
                    I have tested positive for an ALS and/or FTD related
                    mutation
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={
                      "I have tested negative for the ALS and/or FTD related mutation that is present within my family"
                    }
                    onChange={this.onChangeAppliedForGeneticTesting}
                    checked={
                      this.state.options_applied_for_genetic_testing.includes(
                        "I have tested negative for the ALS and/or FTD related mutation that is present within my family"
                      )
                        ? true
                        : false
                    }
                  >
                    I have tested negative for the ALS and/or FTD related
                    mutation that is present within my family
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={
                      "My family currently doesn't know of a specific genetic mutation causative of ALS and/or FTD and I was told I tested negative"
                    }
                    onChange={this.onChangeAppliedForGeneticTesting}
                    checked={
                      this.state.options_applied_for_genetic_testing.includes(
                        "My family currently doesn't know of a specific genetic mutation causative of ALS and/or FTD and I was told I tested negative"
                      )
                        ? true
                        : false
                    }
                  >
                    My family currently doesn't know of a specific genetic
                    mutation causative of ALS and/or FTD and I was told I tested
                    negative
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={
                      this.state.options_applied_for_genetic_testing.includes(
                        "I recently submitted my genetic test and have not yet received my results"
                      )
                        ? true
                        : false
                    }
                    value={
                      "I recently submitted my genetic test and have not yet received my results"
                    }
                    onChange={this.onChangeAppliedForGeneticTesting}
                  >
                    I recently submitted my genetic test and have not yet
                    received my results
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={
                      this.state.options_applied_for_genetic_testing.includes(
                        "I have undergone genetic testing as an observational study participant but have decided to remain blinded from the results"
                      )
                        ? true
                        : false
                    }
                    value={
                      "I have undergone genetic testing as an observational study participant but have decided to remain blinded from the results"
                    }
                    onChange={this.onChangeAppliedForGeneticTesting}
                  >
                    I have undergone genetic testing as an observational study
                    participant but have decided to remain blinded from the
                    results.
                  </Checkbox>
                </li>
              </ul>
            </div>
            <div className="form-group">
              <label className="input-heading">
                If known, which ALS and/or FTD related gene(s) are you affected
                by or have affected your genetic family?
                <span className="text-danger">*</span>
              </label>
              <ul>
                <li>
                  <Checkbox
                    value={"ALS2"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={
                      this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                        "ALS2"
                      )
                        ? true
                        : false
                    }
                  >
                    ALS2
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"ANXA11"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={
                      this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                        "ANXA11"
                      )
                        ? true
                        : false
                    }
                  >
                    ANXA11
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"ATXN2"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={
                      this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                        "ATXN2"
                      )
                        ? true
                        : false
                    }
                  >
                    ATXN2
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"C9orf72"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={
                      this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                        "C9orf72"
                      )
                        ? true
                        : false
                    }
                  >
                    C9orf72
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"CHCHD10"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "CHCHD10"
                    )}
                  >
                    CHCHD10
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"CHMP2B"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "CHMP2B"
                    )}
                  >
                    CHMP2B
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"DCTN1"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "DCTN1"
                    )}
                  >
                    DCTN1
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"DNAJC7"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "DNAJC7"
                    )}
                  >
                    DNAJC7
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"FUS"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "FUS"
                    )}
                  >
                    FUS
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"GLE1"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "GLE1"
                    )}
                  >
                    GLE1
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"KIF5A"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "KIF5A"
                    )}
                  >
                    KIF5A
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"MATR3"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "MATR3"
                    )}
                  >
                    MATR3
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"NEK1"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "NEK1"
                    )}
                  >
                    NEK1
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"OPTN"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "OPTN"
                    )}
                  >
                    OPTN
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"PFN1"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "PFN1"
                    )}
                  >
                    PFN1
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"SETX"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "SETX"
                    )}
                  >
                    SETX
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"SIGMAR1"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "SIGMAR1"
                    )}
                  >
                    SIGMAR1
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"SOD1"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "SOD1"
                    )}
                  >
                    SOD1
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"SPG11"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "SPG11"
                    )}
                  >
                    SPG11
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"SPTLC1"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "SPTLC1"
                    )}
                  >
                    SPTLC1
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"SPTLC2"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "SPTLC2"
                    )}
                  >
                    SPTLC2
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"SQSTM1"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "SQSTM1"
                    )}
                  >
                    SQSTM1
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"TARDBP"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "TARDBP"
                    )}
                  >
                    TARDBP
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"TBK1"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "TBK1"
                    )}
                  >
                    TBK1
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"TUBA4A"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "TUBA4A"
                    )}
                  >
                    TUBA4A
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"UBQLN2"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "UBQLN2"
                    )}
                  >
                    UBQLN2
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"UNC13A"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "UNC13A"
                    )}
                  >
                    UNC13A
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"VAPB"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "VAPB"
                    )}
                  >
                    VAPB
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"VCP"}
                    onChange={this.onChangeAffectedByOrAffectedYourFamilyMember}
                    checked={this.state.als_or_ftd_gene_affected_to_you_or_your_family_member.includes(
                      "VCP"
                    )}
                  >
                    VCP
                  </Checkbox>
                </li>
              </ul>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(7)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
